import { Component } from '@angular/core';
import { Product } from '../../model/product.model';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription, takeUntil, switchMap } from 'rxjs';
import { TOKEN, GUEST_CART_ID } from '../../constants/constant';
import { environment } from '../../environments/environment';
import { Cart, CartItem } from '../../model/cart.model';
import { GuestService } from '../../service/guest.service';
import { ProductService } from '../../service/product.service';
import { StateService } from '../../service/state.service';
import { StorageService } from '../../service/storage.service';
import { UserService } from '../../service/user.service';
import { Data } from '../../model/data.model';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
declare let jQuery: any;

@Component({
  selector: 'app-product-detail',
  imports: [CommonModule, FormsModule],
  templateUrl: './product-detail.component.html',
  styleUrl: './product-detail.component.scss'
})
export class ProductDetailComponent {
  public productDetails: Product = new Product();
  public imageUrl = environment.apiURL;
  public unsubscribe$ = new Subject();
  public guestCartId: string | null;
  token: string | null;
  public activeImageIndex = 0;
  public currentImage = '';
  public subscription: Subscription;
  cart: Cart[] = [];
  window: any = window;
  public height: number = 0;
  intervalId: any;
  heightIntervalId: any;
  videoObj: any;

  constructor(
    private activatedRoute: ActivatedRoute,
    private products: ProductService,
    private guestService: GuestService,
    private localService: StorageService,
    private stateService: StateService,
    private toastr: ToastrService,
    private userService: UserService,
    private metaService: Meta,
    private titleService: Title
  ) { }


  ngAfterViewInit(): void {
    jQuery(document).ready(function () {
      jQuery(".lightbox-image").fancybox({
        buttons: [
          'slideShow',
          'fullScreen',
          'thumbs',
          'share',
          'close',
        ],
        openEffect: 'fade',
        closeEffect: 'fade',
        helpers: {
          media: {}
        },
        slideShow: {
          autoStart: true,
          speed: 100
        },
      });
    });
  }

  getProductDetails() {
    this.activatedRoute.paramMap
      .pipe(
        takeUntil(this.unsubscribe$),
        switchMap((params: Params) => {
          return this.products.getProductDetailsById(params['get']('slug'));
        })
      )
      .subscribe({
        next: (productData: Data<Product[]>) => {

          this.productDetails = productData.data[0];
          this.updateTag(this.productDetails.pageTitle, this.productDetails.metaDescription);
          if (this.cart != null) {
            let cartObj = this.cart.find(
              (x) => x.productId == this.productDetails.productId
            );
            this.productDetails.quantity = cartObj ? cartObj.quantity : 1;
          }
          this.productDetails.imagesArray.sort((a, b) => a.order - b.order);
          this.currentImage = this.productDetails.imageName;
          this.intervalId = setInterval(() => {
            this.activeImageIndex++;
            if (this.activeImageIndex > this.productDetails.imagesArray.length - 1) {
              this.activeImageIndex = 0;
            }
            this.currentImage = this.productDetails.imagesArray[this.activeImageIndex].imageName;
          }, 3000);

          this.heightIntervalId = setInterval(() => {
            this.height = jQuery('.slider-content').get(0)?.offsetHeight;
          }, 100)

          this.stateService.shimmerLoaderUpdate(false);
        },
        error: (err) => {
          this.toastr.error('Something Went Wrong');
        },
      });
  }


  ngOnInit(): void {
    this.token = this.localService.getItem(TOKEN);
    this.stateService.cartDetails$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.cart = res;
        if (this.productDetails.productId)
          if (this.cart != null) {
            let cartObj = this.cart.find(
              (x) => x.productId == this.productDetails.productId
            );
            this.productDetails.quantity = cartObj ? cartObj.quantity : 1;
          }
      });

    this.guestCartId = this.localService.getItem(GUEST_CART_ID);
    this.stateService.shimmerLoaderUpdate(true);
    this.getProductDetails();

    this.stateService.guestUserFetch$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res) {
          this.guestCartId = this.localService.getItem(GUEST_CART_ID);
        }
      });

    this.stateService.tokenFetch$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res) {
          this.token = this.localService.getItem(TOKEN);
        }
      });
  }

  getImageActive(imageIndex: number, imageName: string) {
    this.activeImageIndex = imageIndex;
    this.currentImage = imageName;
    clearInterval(this.intervalId);
    this.intervalId = setInterval(() => {
      this.activeImageIndex++;
      if (this.activeImageIndex > this.productDetails.imagesArray.length - 1) {
        this.activeImageIndex = 0;
      }
      this.currentImage =
        this.productDetails.imagesArray[this.activeImageIndex].imageName;
    }, 3000);
  }

  addToCart(flag: number) {
    let cart: CartItem = {
      skuId: this.productDetails.skuId.toString(),
      quantity: this.productDetails.quantity,
      flag: flag,
    };

    this.updateProduct(cart);
  }

  updateProduct(cart: CartItem) {
    if (this.token) {
      this.userService
        .addProductUserCart(cart)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (res) => {
            this.toastr.info('Added To Cart', '', {
              positionClass: 'toast-bottom-left'
            });
            this.stateService.sendCartUpdated(true);
            this.stateService.showCartSideBar(true);
          },
          error: (err) => {
            this.toastr.error('Something Went Wrong');
          },
        });
    } else {
      this.guestService
        .addProductGuestCart(cart, this.guestCartId)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe({
          next: (res) => {
            this.toastr.info('Added To Cart', '', {
              positionClass: 'toast-bottom-left'
            });
            this.stateService.sendCartUpdated(true);
            this.stateService.showCartSideBar(true);
          },
          error: (err) => {
            this.toastr.error('Something Went Wrong');
          },
        });
    }
  }

  changeQuantity(product: Product, isIncreased: boolean) {
    if (isIncreased) {
      product.quantity != 1 && (product.quantity -= 1);
    } else {
      product.quantity += 1;
    }
  }

  quantityChange(event: any, product: Product) {
    let qty: number = Number(event.target.value);
    qty = qty < 0 ? 1 : qty;
    product.quantity = qty;
  }

  ngOnDestroy() {
    jQuery(".lightbox-image").unbind('click.fb');
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
    clearInterval(this.intervalId);
    clearInterval(this.heightIntervalId);
    // this.metaService.updateTag({ name: 'description', content: 'Herbs.LYF is one of the fastest-growing Camphor Manufacturers in India. We Provide Highest-Quality and 100% Pure Camphor.' });
    // this.titleService.setTitle('Herbs.LYF');
  }

  updateTag(pageTitle: string, metaDescription: string) {
    // this.metaService.updateTag({ name: 'description', content: metaDescription });
    // this.titleService.setTitle(pageTitle);
  }
}
